module.exports = __webpack_public_path__ + "media/images/icon-notice-65764a9b12f91fde3610e6eaf5eb263f.png";